import { maybe } from "@saleor/misc";

import { IFilterElement } from "../../../../components/Filter";
import {
  createFilterTabUtils,
  createFilterUtils,
  getSingleEnumValueQueryParam
} from "../../../../utils/filters";
import {
  levelEnum,
  ProductCategoriesBiFilterKeys,
  ProductCategoriesBiFilterOpts
} from "../../components/ProductCategoriesBiPage/filters";
import {
  ProductCategoriesBiListUrlFilters,
  ProductCategoriesBiListUrlFiltersEnum,
  ProductCategoriesBiListUrlQueryParams
} from "../../url";
export const STORE_DETAILS_FILTERS_KEY = "ProductCategoriesBiFilter";

export function getFilterOpts(
  params: ProductCategoriesBiListUrlFilters
): ProductCategoriesBiFilterOpts {
  return {
    level: {
      active: !!params.level,
      value: maybe(() => params.level, null)
    }
  };
}

export function getFilterVariables(params: ProductCategoriesBiListUrlFilters) {
  return {
    level: maybe(() => Number(params.level), null),
    search: params.query
  };
}

export function getFilterQueryParam(
  filter: IFilterElement<ProductCategoriesBiFilterKeys>
): ProductCategoriesBiListUrlFilters {
  const { name } = filter;

  switch (name) {
    case ProductCategoriesBiFilterKeys.level:
      return getSingleEnumValueQueryParam(
        filter,
        ProductCategoriesBiListUrlFiltersEnum.level,
        levelEnum
      );
  }
}

export const {
  deleteFilterTab,
  getFilterTabs,
  saveFilterTab
} = createFilterTabUtils<ProductCategoriesBiListUrlFilters>(
  STORE_DETAILS_FILTERS_KEY
);

export const { areFiltersApplied, getActiveFilters } = createFilterUtils<
  ProductCategoriesBiListUrlQueryParams,
  ProductCategoriesBiListUrlFilters
>({
  ...ProductCategoriesBiListUrlFiltersEnum
});
